import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const COOKIE_KEY = "cookie-consent";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(COOKIE_KEY)) {
        const timer = setTimeout(() => setVisible(true), 4000);
        return () => clearTimeout(timer);
      }
    } catch {
      // localStorage unavailable
    }
  }, []);

  const handleChoice = (accepted: boolean) => {
    try {
      localStorage.setItem(COOKIE_KEY, accepted ? "accepted" : "declined");
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 px-4 py-2 animate-fade-in-up">
      <div className="max-w-4xl mx-auto bg-card/95 backdrop-blur-sm border border-border rounded-lg shadow-md px-4 py-2.5 flex flex-col sm:flex-row items-center gap-3">
        <p className="text-xs text-muted-foreground leading-snug flex-1">
          We use cookies to improve performance and analyze traffic.{" "}
          <Link to="/privacy" className="text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
            Privacy Policy
          </Link>
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <Button size="sm" className="h-7 text-xs px-3" onClick={() => handleChoice(true)}>
            Accept
          </Button>
          <button onClick={() => handleChoice(false)} className="text-muted-foreground hover:text-foreground transition-colors" aria-label="Decline cookies">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
